import React from 'react'

const Navbar=()=>{
    return(
        <nav className="navbar-nav navbar-dark bg-dark navbar-expand-md">
            <div className="container">
                <a href="" className="navbar-brand">Weather App</a>
            </div>
        </nav>
    )
}

export default Navbar